<template>
  <div>
		<div class="navbar">
			<b-button v-if="!isQrCodeSearch" to="/" :data="data" :convertionsData="convertionsData" :applicationsData="applicationsData" :vCleanCodes="vCleanCodes" :competitorCodes="competitorCodes" variant="outline-light">
				NOVA PESQUISA
			</b-button>
			<b-button v-if="isQrCodeSearch" to="/codigovclean" :data="data" :convertionsData="convertionsData" :applicationsData="applicationsData" :vCleanCodes="vCleanCodes" :competitorCodes="competitorCodes" variant="outline-light">
				NOVA PESQUISA
			</b-button>
		</div>
		<b-container>
			<b-row>
				<b-col cols="12">
					<span class="title">CÓDIGO:</span>
					<span>{{ item && item.vehicleCode }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">CONEXÃO:</span>
					<span>{{ item && item.connection }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">GRUPO:</span>
					<span>{{ item && item.group }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" :md="12">
					<b-card
						no-body
						v-if="item && item.photo"
						:img-src="item.photo">

						<b-embed
							type="iframe"
							v-if="item && item.video"
							:src="item.video"
							allowfullscreen />
					</b-card>
				</b-col>
			</b-row>
			<b-row v-if="item.vehiclePhotos">
				<b-col cols="12" :md="12">
					<b-card no-body>
						<b-carousel
							id="carousel"
							:interval="4000"
							controls
							indicators
							no-hover-pause
							img-width="100%"
							background="#ababab"
							style="width: 100%; max-height: 500px; text-shadow: 1px 1px 2px #333;">

							<b-carousel-slide v-for="photo in item.vehiclePhotos" :key="photo" 
								:img-src="photo">
							</b-carousel-slide>

						</b-carousel>
					</b-card>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<div class="column-header">
					<span class="column-header-title">APLICAÇÕES</span>
					<span v-for="app in item.applications" :key="app.model">
						{{ app.model }}
					</span>
				</div>
			</b-row>
		</b-container>
		<div id="modal" class="modal">
			<span class="modal-close">&times;</span>
			<img class="modal-content" id="modal-image">
		</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
	name: 'ApplicationsDetail',
	props: {
		code: String,
		data: Array,
		convertionsData: Array,
		applicationsData: Array,
		vCleanCodes: Array,
		competitorCodes: Array
	},

	data() {
		return {
			item: {},
			isQrCodeSearch: this.$router.currentRoute.fullPath.includes('codigovclean'),
		};
	},

	methods: {
		init: function() {
			this.item = this.applicationsData.find(item => item.vehicleCode.toUpperCase() === this.code.toUpperCase());
		}
	},
	
	mounted() {
		this.init();
	}
};
</script>

<style scoped>
	input[type='text'] {
		margin-bottom: 15px;
	}
	.navbar {
		margin-bottom: 15px;
		background-color: #e9ecef;
		border: 1px solid #dfe4e8;
		border-radius: calc(0.25rem - 1px);
	}
	.title {
		font-weight: bold;
		margin-right: 5px;
	}
	.description {
		padding: 15px 10px;
	}
	.card {
		align-items: center;
		margin-top: 30px;
		padding: 10px;
	}
	.card-img {
		cursor: pointer;
		transition: 0.3s;
		width: 75%;
	}
	.card-img:hover {
		opacity: 0.8;
	}
	.column-header {
		width: 100%;
		font-weight: bold;
		padding: 5px 0;
		background-color: #e9ecef;
		border: 1px solid #dfe4e8;
		border-radius: calc(0.25rem - 1px);
		margin-bottom: 10px;
	}
	.column-header > span {
		display: block;
	}
	.column-header-title {
		padding-bottom: 10px;
		font-weight: bold;
	}
	.carousel-control-prev-icon, .carousel-control-next-icon {
		background-color: grey !important;
	}
</style>
